export default __webpack_public_path__ + "static/media/wippy_download_page_google_app_store_text.2d504faf.svg";